import { inject } from "@angular/core";
import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { CustomToastService } from "@shared/services/custom-toast/custom-toast.service";
import { ConnectivityService } from "@shared/services/connectivity/connectivity.service";
import { getHttpErrorMessageKey } from "@shared/helpers/get-http-error-message-key.helper";
import { isNetworkHttpError } from "@shared/helpers/http-error-predicates.helper";

const SKIP_HANDLE_ERROR_HEADER: string = "Skip-Handle-Error";
const TOAST_DURATION_MS: number = 3000;

export const errorInterceptor: HttpInterceptorFn = (request, next) => {
  const customToastService: CustomToastService = inject(CustomToastService);
  const connectivityService: ConnectivityService = inject(ConnectivityService);

  const notify: (error: HttpErrorResponse) => void = (error: HttpErrorResponse): void => {
    if (request.headers.get(SKIP_HANDLE_ERROR_HEADER) === "true") return;

    const messageKey: ReturnType<typeof getHttpErrorMessageKey> = getHttpErrorMessageKey(error.status, request.url);
    const showToast: () => void = (): void =>
      customToastService.show({ message: messageKey, type: "error", duration: TOAST_DURATION_MS });

    if (!isNetworkHttpError(error)) {
      showToast();
      return;
    }

    void connectivityService.verify().then((isOnline: boolean): void => {
      if (isOnline) showToast();
    });
  };

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      notify(error);

      return throwError(() => error);
    }),
  );
};
